import React, { useState } from "react";
import SectionHeader from "../components/ui/sectionHeader/SectionHeader";
import TabComp from "../components/ui/tabcomp/TabComp";
import TextInput from "../components/ui/input/TextInput";
import SelectInput from "../components/ui/input/SelectInput";
import PrimaryButton from "../components/ui/button/PrimaryButton";
import car from "../assets/images/car.png";
import { plateCodeList } from "../helpers/plateCodeList";
import { useDispatch, useSelector } from "react-redux";
import { getTransDtls } from "../components/JsonToSoapXml/getTransDtls";
import LoadingMask from "../components/loadingMask/LoadingMask";
import SectionLargeTitle from "../components/ui/sectionTitle/SectionLargeTitle.js";
import { getTransDtlsSoap } from "../components/SoapXmlToJson/getTransDtlsSoap.js";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmBox from "../components/modal/ConfirmBox.js";
import axios from "axios";
import { getValidAccessToken } from "../services/oauthservice.js";
import { createApiLog } from "../helpers/apiLogger.js";
import { encryptRSA } from "../services/encrypt.js";

export default function PayPremium() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    mobileNo: "",
    plateNumber: "",
    plateCode: "",
    civilId: "",
    quoteNo: "",
  });
  const [activeTab, setActiveTab] = useState(0);
  const { partnerDetail } = useSelector((state) => state.domainReducer);
  const { loading } = useSelector((state) => state.loadingReducer);
  const [showModal, setShowModal] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const { partnerConfig } = useSelector((state) => state.partnerConfig || {});
  const { SRC_BUS_ID = 'CP', PARTNER_ID } = partnerConfig || {};
  const location = useLocation();
  const incomingData = location.state;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const requiredFields = {
    0: ["plateNumber", "plateCode", "civilId"],
    1: ["plateNumber", "plateCode", "mobileNo"],
    2: ["quoteNo"],
  };

  const isFormValid = requiredFields[activeTab].every((field) => {
    const value = formData[field]?.trim(); // Ensure it's a string

    if (field === "mobileNo") {
      return /^\d{10}$/.test(value);
    }

    if (field === "plateNumber") {
      return /^[a-zA-Z0-9]{2,5}$/.test(value);
    }

    return !!value;
  });

  const tabsData = [
    {
      title: "Plate & Civil Id",
      content: (
        <div className="row">
          <div className="col-md-6">
            <TextInput
              label="Plate Number"
              type="text"
              name="plateNumber"
              value={formData.plateNumber}
              onChange={handleChange}
              required={true}
              placeholder="Enter your Plate Number"
              requiredMsg="Please enter your Plate Number"
            />
          </div>
          <div className="col-md-6">
            <SelectInput
              label="Plate Code"
              name="plateCode"
              value={formData.plateCode}
              onChange={handleChange}
              options={plateCodeList}
              required={true}
              requiredMsg="Please enter your Plate Code"
            />
          </div>
          <div className="col-md-6">
            <TextInput
              label="Civil ID / License No"
              type="text"
              name="civilId"
              value={formData.civilId}
              onChange={handleChange}
              required={true}
              placeholder="Enter your Civil Id"
              requiredMsg="Please enter your Civil ID / License No"
            />
          </div>
        </div>
      ),
    },
    {
      title: "Plate & Mobile No",
      content: (
        <div className="row">
          <div className="col-md-6">
            <TextInput
              label="Plate Number"
              type="text"
              name="plateNumber"
              value={formData.plateNumber}
              onChange={handleChange}
              required={true}
              placeholder="Enter your Plate Number"
              requiredMsg="Please enter your Plate Number"
            />
          </div>
          <div className="col-md-6">
            <SelectInput
              label="Plate Code"
              name="plateCode"
              value={formData.plateCode}
              onChange={handleChange}
              options={plateCodeList}
              required={true}
              requiredMsg="Please enter your Plate Code"
            />
          </div>
          <div className="col-md-6">
            <TextInput
              label="Mobile Number"
              type="text"
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleChange}
              required={true}
              placeholder="Enter your Mobile Number"
              requiredMsg="Please enter your Mobile Number"
            />
          </div>
        </div>
      ),
    },
    {
      title: "Quote No",
      content: (
        <div className="row">
          <div className="col-md-12">
            <TextInput
              label="Quote No"
              type="text"
              name="quoteNo"
              value={formData.quoteNo}
              onChange={handleChange}
              required={true}
              placeholder="Enter your Quote No"
              requiredMsg="Please enter your Quote No"
            />
          </div>
        </div>
      ),
    },
  ];

  const handleTabChange = (index) => {
    setActiveTab(index);
    setFormData((prevData) =>
      Object.keys(prevData).reduce((acc, key) => ({ ...acc, [key]: "" }), {})
    );
  };

  const updateTransDetail = async (quoteNo) => {
    const formDataUpdate = new FormData();
    const selectedInputType =
      activeTab === 0
        ? "Plate & Civil Id"
        : activeTab === 1
          ? "Plate & Mobile No"
          : "Quote No";

    const formDataLog = {
      transId: incomingData.transId,
      plateNumber: formData.plateNumber,
      plateCode: formData.plateCode,
      licenseNo: formData.civilId,
      quoteNo,
      selectedInputType,
    };

    const encrypted = await encryptRSA(formDataLog);

    formDataUpdate.append("encrypted", JSON.stringify(encrypted));

    try {
      const token = await getValidAccessToken();

      const response = await axios.put(
        `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/leads`,
        formDataUpdate,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      await createApiLog({
        PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: incomingData.transId,
        API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/leads`,
        REQUEST: formDataLog, // store plain readable log
        REQUEST_STATUS: "SUCCESS",
        RESPONSE: response?.data ?? response,
      });
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);

      await createApiLog({
        PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: incomingData.transId,
        API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/leads`,
        REQUEST: formDataLog,
        REQUEST_STATUS: "FAILED",
        RESPONSE: error.response?.data ?? error,
      });
    }
  };

  const handleClick = async () => {
    const soapRequest = getTransDtls({ ...formData, txnTyp: "Q", srcBusId: SRC_BUS_ID });

    try {
      dispatch({ type: "LOADING", payload: true });
      const response = await fetch(
        `${process.env.REACT_APP_GET_TRANS_DTLS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "text/xml",
          },
          body: soapRequest,
        }
      );

      const responseText = await response.text();

      await createApiLog({
        PARTNER_ID: PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: incomingData?.transId,
        API: process.env.REACT_APP_GET_TRANS_DTLS,
        REQUEST: soapRequest,
        REQUEST_STATUS: "SUCCESS",
        RESPONSE: responseText,
      })

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseText, "text/xml");

      const extractedData = getTransDtlsSoap(xmlDoc);

      if (extractedData.error) {
        console.error("Error:", extractedData.error);
        setErrMessage(extractedData.error);
        setShowModal(true);
        dispatch({ type: "LOADING", payload: false });
        // await handleData(extractedData.error, 1);
      } else {
        const updateTransResult = await updateTransDetail(extractedData.quoteNo);
        dispatch({ type: "LOADING", payload: false });
        // await handleData(extractedData, 2);
        navigate("/get-quote", {
          state: { ...extractedData, transId: incomingData.transId },
        });

        // handleConfirmRenew(extractedData)
      }

      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      console.error("Error:", error);

      await createApiLog({
        PARTNER_ID: PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: incomingData?.transId,
        API: process.env.REACT_APP_GET_TRANS_DTLS,
        REQUEST: soapRequest,
        REQUEST_STATUS: "Error",
        RESPONSE: error,
      })
    }
  };

  const handleCloseConfirm = () => {
    setErrMessage("");
    setShowModal(false);
  };

  return (
    <>
      {loading && <LoadingMask />}

      <ConfirmBox
        show={showModal}
        message={errMessage}
        onCancel={handleCloseConfirm}
      />

      <div className="container">
        {/* Section Header */}
        <div className="row mb-1">
          <div className="col-md-12">
            <SectionHeader title="Motor Insurance " stepNo={1} totalStep={3} />
          </div>
        </div>
        {partnerDetail?.LOGO && (
          <div className="container bg-white">
            <div className="row mt-2 mb-1">
              <div className="col-md-12 mt-2 mb-2 d-flex justify-content-center">
                <img
                  src={partnerDetail?.LOGO}
                  style={{ height: "65px" }}
                  alt="partnerlogo"
                />
              </div>
            </div>
          </div>
        )}
        <div className="container bg-white">
          <div className="row mt-2">
            <div className="col-md-12 mt-3">
              <SectionLargeTitle title="Pay Premium" />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-6">
              <TabComp tabs={tabsData} onTabChange={handleTabChange} />
              <PrimaryButton
                label="PROCEED TO PAY"
                onClick={handleClick}
                disabled={!isFormValid}
              />
            </div>
            <div className="col-md-6">
              <img src={car} className="img-fluid w-auto" alt="car" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
